import * as z from "zod/v4";
import { InventoryViewType } from "./inventory-view-type";

export const createInventoryViewFolder = {
  name: "createInventoryViewFolder" as const,
  input: z.object({ viewType: InventoryViewType, name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
